const de = {
  common: {
    facts: "Auf einen Blick",
    why: "Warum das Hotel Ciutat Martorell",
    related: "Das könnte Sie auch interessieren",
    quoteEyebrow: "Erzählen Sie uns von Ihrer Hochzeit",
  },
  nearSeat: {
    seoTitle: "Hotel nahe SEAT-CUPRA Martorell · 5 Min. vom Werk",
    seoDesc: "4-Sterne-Hotel 5 Minuten vom SEAT-CUPRA-Werk und den Gewerbegebieten von Martorell. Firmenraten, Glasfaser-WLAN, Parkplatz, Restaurant und Bahnhof in 100 m.",
    eyebrow: "Hotel für Besuche bei SEAT-CUPRA",
    title: ["Ihr Hotel 5 Minuten", "von SEAT-CUPRA Martorell"],
    intro: "Zulieferer, Ingenieure, Trainer und Projektteams übernachten bei uns, weil das Werk und die Gewerbegebiete von Martorell um die Ecke liegen – und der Zug nach Barcelona 100 Meter entfernt hält.",
    facts: [
      { k: "SEAT-CUPRA-Werk", v: "5 Min. mit dem Auto" },
      { k: "Renfe und FGC", v: "100 m" },
      { k: "Barcelona", v: "30 Min." },
      { k: "Flughafen El Prat", v: "25 Min." },
    ],
    sections: [
      { h: "Gemacht für den Arbeitsaufenthalt", p: "21 m² große Zimmer mit Schreibtisch, kostenlosem Glasfaser-WLAN und Klimaanlage. Frühstücksbuffet von 06:30 bis 10:30 Uhr, damit Sie die Frühschicht pünktlich erreichen, 24-h-Rezeption für späte Anreisen und Business Corner zum Drucken oder Fertigstellen eines Berichts." },
      { h: "Firmenraten und zentrale Abrechnung", p: "Für Unternehmen, die das Werk regelmäßig besuchen, bieten wir verhandelte Raten, zentrale Rechnungsstellung und eine schnelle Abwicklung von Teambuchungen. Nennen Sie uns das ungefähre Übernachtungsvolumen – wir erstellen ein Angebot." },
      { h: "Meetings und Schulungen direkt neben dem Werk", p: "Drei Tagungsräume mit Tageslicht von 35 bis 220 m² für Lieferantenschulungen, Kick-offs oder Audits, mit Beamer, Glasfaser und Kaffeepausen. Dazu das Restaurant My Bar für Arbeitsessen mit Business-Menü von Montag bis Freitag." },
    ],
    why: [
      "5 Autominuten vom SEAT-CUPRA-Werk und den Gewerbegebieten von Martorell",
      "Privatparkplatz direkt am Hotel (gegen Aufpreis)",
      "Kostenloses Glasfaser-WLAN und Schreibtisch in jedem Zimmer",
      "Frühstück ab 06:30 Uhr und 24-Stunden-Rezeption",
      "Firmenraten mit zentraler Abrechnung",
    ],
    faqTitle: "Übernachten in der Nähe von SEAT-CUPRA",
    cta: { title: "Direkt buchen oder Firmenrate anfragen", text: "Buchen Sie auf der offiziellen Website mit Bestpreisgarantie oder fragen Sie eine Firmenrate für Ihr Team an.", secondary: "Firmenraten", secondaryTo: "corporate" },
    related: [
      { to: "corporate", label: "Businesshotel" },
      { to: "meetingRooms", label: "Tagungsräume" },
      { to: "blogPost", params: { slug: "donde-alojarse-si-visitas-martorell-por-trabajo" }, label: "Wo übernachten bei einer Geschäftsreise nach Martorell" },
    ],
  },
  nearMontserrat: {
    seoTitle: "Hotel nahe Montserrat · 20 Min. vom Kloster",
    seoDesc: "4-Sterne-Hotel in Martorell, 20 Autominuten von Montserrat, mit FGC-Bahnhof in 100 m Richtung Zahnradbahn. Komfortable Basis für Kloster und Barcelona.",
    eyebrow: "Hotel für den Besuch von Montserrat",
    title: ["Montserrat in 20 Minuten,", "Barcelona in 30"],
    intro: "Martorell ist der perfekte Mittelpunkt: morgens das Kloster und die Berge von Montserrat, nachmittags Barcelona. Und abends ein ruhiges Zimmer mit Restaurant und Parkplatz.",
    facts: [
      { k: "Kloster Montserrat", v: "20 Min. mit dem Auto" },
      { k: "FGC-Bahn zur Zahnradbahn", v: "100 m vom Hotel" },
      { k: "Barcelona", v: "30 Min." },
      { k: "Flughafen El Prat", v: "25 Min." },
    ],
    sections: [
      { h: "So kommen Sie vom Hotel nach Montserrat", p: "Mit dem Auto 20 Minuten bis zum Kloster oder zum Parkplatz der Zahnradbahn in Monistrol. Mit öffentlichen Verkehrsmitteln: Der FGC-Bahnhof liegt 100 Meter entfernt – Linie R5 bis Monistrol de Montserrat und weiter mit der Zahnradbahn, oder bis Montserrat-Aeri und hinauf mit der Seilbahn." },
      { h: "Ein Tag in den Bergen, eine Nacht Erholung", p: "Nach Basilika, Escolania-Chor oder einer Wanderung nach Sant Jeroni kehren Sie in ein 21 m² großes Zimmer mit Klimaanlage, Duschbad und Glasfaser-WLAN zurück. Abendessen im Restaurant My Bar mit mediterraner Marktküche und Weinen aus dem Penedès." },
      { h: "Montserrat mit Barcelona verbinden", p: "Von den Bahnhöfen Renfe und FGC ist Barcelona etwa 30 Minuten entfernt. Widmen Sie einen Tag Montserrat und einen der Stadt – ohne Hotelwechsel und ohne Parkplatzsuche im Zentrum." },
    ],
    why: [
      "20 Autominuten vom Kloster Montserrat",
      "FGC-Bahnhof in 100 m mit Anschluss an Zahnradbahn und Seilbahn",
      "Privatparkplatz – Auto stehen lassen und mit dem Zug fahren",
      "Restaurant My Bar mit mediterraner Küche und Penedès-Weinen",
      "Frühstücksbuffet von 06:30 bis 10:30 Uhr für einen frühen Start in die Berge",
    ],
    faqTitle: "Montserrat vom Hotel aus besuchen",
    cta: { title: "Buchen Sie Ihre Basis für Montserrat", text: "Direkt auf der offiziellen Website buchen – mit Bestpreisgarantie. Sie reisen als Gruppe? Fragen Sie uns nach einem Angebot.", secondary: "Anfahrt zum Hotel", secondaryTo: "location" },
    related: [
      { to: "blogPost", params: { slug: "como-llegar-a-montserrat-desde-martorell" }, label: "Von Martorell nach Montserrat" },
      { to: "location", label: "Lage und Anfahrt" },
      { to: "blogPost", params: { slug: "que-visitar-cerca-de-martorell" }, label: "Sehenswertes in der Nähe von Martorell" },
    ],
  },
  parkingBarcelona: {
    seoTitle: "Hotel mit Parkplatz nahe Barcelona · 30 Min. mit dem Zug",
    seoDesc: "4-Sterne-Hotel mit Privatparkplatz in Martorell, 30 Minuten von Barcelona. Auto abstellen und mit Renfe oder FGC vom Bahnhof in 100 m in die Stadt fahren. Direkt buchen.",
    eyebrow: "Hotel mit Parkplatz",
    title: ["Auto parken,", "Barcelona in 30 Minuten"],
    intro: "Wer mit dem Auto nach Barcelona kommt, schläft außerhalb des Zentrums ruhiger und einfacher: Privatparkplatz am Hotel und direkter Zug in die Stadt, 100 Meter vor der Tür.",
    facts: [
      { k: "Privatparkplatz", v: "am Hotel" },
      { k: "Bahnhöfe Renfe und FGC", v: "100 m" },
      { k: "Zentrum Barcelona", v: "30 Min." },
      { k: "Flughafen El Prat", v: "25 Min." },
    ],
    sections: [
      { h: "Privatparkplatz direkt am Hotel", p: "Private Stellplätze für Hotelgäste (gegen Aufpreis) – keine Parkplatzsuche, keine Parkhausgebühren im Zentrum von Barcelona. Kommen und gehen Sie, wann Sie möchten; das Auto steht wenige Schritte von Ihrem Zimmer." },
      { h: "Mit dem Zug nach Barcelona, ohne Stau", p: "Die Bahnhöfe von Renfe (Rodalies) und FGC liegen 100 Meter entfernt. In rund 30 Minuten sind Sie im Zentrum; auf dem Rückweg wartet das Auto. Für Ausflüge in die Provinz liegen A-2 und AP-7 direkt nebenan." },
      { h: "Ein komplettes Hotel für den Kurzurlaub", p: "92 Zimmer mit 21 m² und Glasfaser-WLAN, Restaurant My Bar, Fitnessraum und Frühstücksbuffet von 06:30 bis 10:30 Uhr. Ideal für Familien und Paare, die Barcelona oder Montserrat mit dem Auto besuchen." },
    ],
    why: [
      "Privatparkplatz für Gäste am Hotel",
      "Züge nach Barcelona in 100 m: Renfe und FGC",
      "30 Minuten von Barcelona und 25 vom Flughafen",
      "Doppel- und Twin-Zimmer mit 21 m² und Glasfaser-WLAN",
      "Restaurant, Fitnessraum und 24-h-Rezeption",
    ],
    faqTitle: "Parken und nach Barcelona kommen",
    cta: { title: "Mit Parkplatz buchen und das Auto vergessen", text: "Direkt auf der offiziellen Website buchen – mit Bestpreisgarantie – und uns sagen, ob Sie mit dem Auto anreisen.", secondary: "Hotelservices", secondaryTo: "services" },
    related: [
      { to: "blogPost", params: { slug: "como-ir-de-martorell-a-barcelona" }, label: "Von Martorell nach Barcelona" },
      { to: "services", label: "Hotelservices" },
      { to: "blogPost", params: { slug: "transportes-entre-martorell-y-barcelona" }, label: "Verkehrsmittel zwischen Martorell und Barcelona" },
    ],
  },
  weddingsBaix: {
    seoTitle: "Hochzeitshotel im Baix Llobregat · Martorell",
    seoDesc: "Feiern Sie Ihre Hochzeit in Martorell: Bankettsaal für bis zu 150 Gäste, Cocktail für bis zu 200 auf der Terrasse, Degustationsmenü, Hochzeitszimmer und Gästeraten.",
    eyebrow: "Hochzeiten im Baix Llobregat",
    title: ["Ihre Hochzeit im Baix Llobregat,", "alles unter einem Dach"],
    intro: "Cocktail auf der Terrasse, Bankett in einem 220 m² großen Saal mit Tageslicht, eigene mediterrane Küche und 92 Zimmer, damit niemand nach Hause fahren muss. 30 Minuten von Barcelona und gut angebunden an die ganze Region.",
    facts: [
      { k: "Bankett", v: "bis zu 150 Gäste" },
      { k: "Cocktail", v: "bis zu 200 Personen" },
      { k: "Bankettsaal", v: "220 m² mit Tageslicht" },
      { k: "Zimmer", v: "92 für Ihre Gäste" },
    ],
    sections: [
      { h: "Räume: Terrasse, Saal und Zimmer", p: "Der Begrüßungscocktail auf der Terrasse, das Bankett im teilbaren Bankettsaal mit 220 m² und zum Abschluss das kostenfreie Hochzeitszimmer sowie Sonderraten für Gäste, die über Nacht bleiben." },
      { h: "Eigene Küche und Degustationsmenü", p: "Unser Küchenteam stellt maßgeschneiderte Hochzeitsmenüs mit saisonalen mediterranen Produkten und Weinen aus dem Penedès zusammen. Vor dem großen Tag gibt es eine Verkostung, um jedes Gericht mit dem Paar festzulegen." },
      { h: "Ein Koordinator vom ersten Kaffee an", p: "Festes Angebot innerhalb von 48 Stunden, ohne Überraschungen. Ein persönlicher Koordinator kümmert sich um Ablauf, Dienstleister, DJ und die optionale offene Bar – das Paar muss nur genießen." },
    ],
    why: [
      "Leicht erreichbar für Gäste aus Barcelona und der ganzen Region: 30 Min. mit dem Auto, Bahnhof in 100 m",
      "220 m² Saal mit Tageslicht und Terrasse für den Cocktail",
      "Kostenfreies Hochzeitszimmer und Sonderraten für Gäste",
      "Vorheriges Degustationsmenü und eigene mediterrane Küche",
      "Persönlicher Koordinator und festes Angebot in 48 Stunden",
    ],
    faqTitle: "Die Hochzeit im Hotel feiern",
    cta: { title: "Erzählen Sie uns, wie Sie sich Ihre Hochzeit vorstellen", text: "Nennen Sie uns das ungefähre Datum, die Gästezahl und Ihre Wünsche – wir antworten innerhalb von 48 Stunden mit einem Angebot." },
    related: [
      { to: "weddings", label: "Hochzeiten im Hotel" },
      { to: "events", label: "Events und Feiern" },
      { to: "meetingRoomDetail", params: { slug: "salon-montserrat" }, label: "Bankettsaal" },
    ],
  },
};

export default de;
